import { render, staticRenderFns } from "./RoleClients.vue?vue&type=template&id=5547d0f1&"
import script from "./RoleClients.vue?vue&type=script&lang=ts&"
export * from "./RoleClients.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports